import {
  prettify,
  renderEUDate,
  renderEUDateTime,
  renderEUTime,
} from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { reportTypes } from "../../components/ReportComponents";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
const columns = [
  {
    size: 100,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterVariant: "select",
    accessorFn: (row) => `${row.first_name} ${row.last_name}`,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.isOutOfBounds) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Paziente",
  },
  {
    size: 30,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) => renderEUTime(row.recap.date),
    enableColumnFilter: false,
    header: "Ora",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["Temperature"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    accessorFn: (row) =>
      row.recap.data.Temperature === undefined
        ? ""
        : `${row.recap.data.Temperature}°C`,
    header: "Temperatura",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["Pmax"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) =>
      row.recap.data.Pmax === undefined ? "" : `${row.recap.data.Pmax}`,
    header: "Pressione sis.",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["Pmin"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) =>
      row.recap.data.Pmin === undefined ? "" : `${row.recap.data.Pmin}`,
    header: "Pressione dia.",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["HR"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) =>
      row.recap.data.HR === undefined ? "" : `${row.recap.data.HR}`,
    header: "HR",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["SPO2"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) =>
      row.recap.data.SPO2 === undefined ? "" : `${row.recap.data.SPO2}`,
    header: "SPO2",
  },
  {
    size: 5,
    enableColumnFilter: false,
    accessorFn: (row) => (row.alert ? "true" : "false"),
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <CloseIcon color="error" />
      ) : (
        <DoneIcon color="success" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Alert",
  },
  {
    size: 25,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    accessorKey: "org_name",
    filterVariant: "select",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Org",
  },
];

export default columns;
